// Module
var code = "<template>\n\t<div class=\"container-fluid\">\n\t\t<router-view></router-view>\n\t</div>\n</template>\n";
// Exports
export default code;